import { z } from "zod";
import { roomSchema } from "./roomSchema";
import { contactFormEdit } from "./contactFormValidation";

export const broadcastMemberSchema = roomSchema.extend({...contactFormEdit.shape, state: z.enum(['blue-tick', 'green-tick', 'red-cross', 'unchecked'])});

const brocastFilterTypeEnum = z.enum(['all', 'applicable', 'unapplicable']);

export const baseBroadcastFormSchema = z.object({
  sender_phone: z.string().nonempty("Sender phone is required"),
  allow_personal: z.boolean(),
  allow_group: z.boolean(),
  applicable: z.array(broadcastMemberSchema),
  must_send: z.array(broadcastMemberSchema),
  dont_send: z.array(broadcastMemberSchema),
  unapplicable: z.array(broadcastMemberSchema),
  new_members: z.array(z.string()),
  broadcast_name: z.string().nonempty("Broadcast name is required"),
  send_to_company_categories: z.array(z.string()).optional().nullable(),
  send_to_company_types: z.array(z.string()).optional().nullable(),
  send_to_account_designations: z.array(z.string()).optional().nullable(),
});

// Common refinement for broadcast forms
const withBroadcastRefinements = <T extends z.ZodType>(schema: T) => 
  schema.refine((data) => data.allow_personal || data.allow_group, {
    message: "At least one of Personal or Group must be selected.",
    path: ["allow_personal", "allow_group"],
});

// Apply the common refinement to the base schema
export const broadcastCreateFormSchema = withBroadcastRefinements(baseBroadcastFormSchema);

// Extend the base schema with ID field and apply the same refinement
export const broadcastEditFormSchema = withBroadcastRefinements(
  baseBroadcastFormSchema.extend({
    id: z.string(),
    room_id: z.string(),
  })
);

export type IBroadcastMemberSchema = z.infer<typeof broadcastMemberSchema>;
export type IBroadcastCreateFormSchema = z.infer<typeof broadcastCreateFormSchema>;
export type IBroadcastEditFormSchema = z.infer<typeof broadcastEditFormSchema>;
export type IBroadcastFilterType = z.infer<typeof brocastFilterTypeEnum>;